<div class="flex items-center justify-between gap-5 px-5 py-[15px] bg-white rounded-b-[5px]">
  <span class="text-[14px] fg-gris-1">
    {{ 'common.pagination.total' | translate: { total: pagination().total } }}
  </span>

  <div class="flex items-center gap-[15px]">
    <button type="button" (click)="previous()" [disabled]="disabled() || !hasPrevious()"
      class="border border-gris-3 rounded-[5px] h-[48px] px-5 flex items-center fg-noir-2 text-[16px] font-medium cursor-pointer hover:bg-gris-4 transition-colors bg-white disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white">
      {{ 'common.pagination.previous' | translate }}
    </button>

    <span class="text-[16px] font-semibold fg-noir-2 whitespace-nowrap">
      {{ 'common.pagination.page_of' | translate: { page: pagination().page, total: totalPages() } }}
    </span>

    <button type="button" (click)="next()" [disabled]="disabled() || !pagination().has_more"
      class="border border-gris-3 rounded-[5px] h-[48px] px-5 flex items-center fg-noir-2 text-[16px] font-medium cursor-pointer hover:bg-gris-4 transition-colors bg-white disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white">
      {{ 'common.pagination.next' | translate }}
    </button>
  </div>
</div>
